// extracted by mini-css-extract-plugin
export default {"maxImages":"selfhelp_maxImages__w+Ruq","fullscreen":"selfhelp_fullscreen__FlNc9","fullscreenContent":"selfhelp_fullscreenContent__J6tkC"};